import { AfterViewInit, Component, ElementRef, ViewChild, inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormBuilder, Validators } from '@angular/forms';
import { Router, RouterLink } from '@angular/router';
import { AlertCardComponent } from '../alertCard/alertCard.component';

import { LoginRequest } from '../../models/login';
import { LoginService } from '../../service/login.services';
import { GeneralService } from '../../service/general.service';



@Component({
  selector: 'app-signin',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    RouterLink,
    AlertCardComponent
  ],
  templateUrl: './sign-in.html',
  styleUrls: ['./sign-in.scss']
})
export class Signin implements AfterViewInit {

  @ViewChild('usernameInput', { static: true }) usernameInput!: ElementRef<HTMLInputElement>;

  currentYear = new Date().getFullYear();
  private fb = inject(FormBuilder);
  private router = inject(Router);
  private loginService = inject(LoginService);
  private generalService = inject(GeneralService);


  loading = signal(false);

  showAlert = signal(false);
  alertMessage = signal('');
  alertType = signal<'success' | 'error'>('error');
  licenciaDescripcion = signal('Licencia');


  ngOnInit(): void {
    this.generalService.get('GET_LICENCIA').subscribe({
      next: res => {
        if (res && res.length > 0) {
          this.licenciaDescripcion.set(res[0].valor);
        }
      },
      error: () => {
        // Si falla, se queda el texto por defecto
      }
    });
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.usernameInput?.nativeElement?.focus();
    }, 0);
  }

  form = this.fb.group({
    username: ['', Validators.required],
    password: ['', [Validators.required, Validators.minLength(3)]]
  });

  onSubmit(): void {
    if (this.loading()) {
      return;
    }

    this.form.markAllAsTouched();
    this.showAlert.set(false);

    if (this.form.invalid) {
      this.alertType.set('error');
      this.alertMessage.set('Complete todos los campos correctamente.');
      this.showAlert.set(true);
      return;
    }

    this.loading.set(true);

    const payload: LoginRequest = {
      email: this.form.value.username!.trim().toLowerCase(),
      password: this.form.value.password!
    };

    this.loginService.login(payload).subscribe({
      next: res => {
        this.loading.set(false);

        if (res.error === 0) {
          localStorage.setItem('authUser', JSON.stringify({
            pkUsuario: res.pkUsuario,
            nombre: res.nombreUsuario,
            email: payload.email,
            transactions: res.transacciones ?? []
          }));
          this.router.navigate(['/home']);
        } else {
          this.alertType.set('error');
          this.alertMessage.set(res.mensaje);
          this.showAlert.set(true);
        }
      },
      error: () => {
        this.loading.set(false);
        this.alertType.set('error');
        this.alertMessage.set('Error de conexión con el servidor.');
        this.showAlert.set(true);
      }
    });
  }

  showPassword = signal(false);

  togglePassword(): void {
    this.showPassword.update(v => !v);
  }

}
